import { useMemo } from "react";

import useTableSort from "components/Table/useTableSort";

import {
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
  MODULE_VERSION_EXAMPLES_TABLE_FILTERS_STORAGE_KEY,
  SORT_CONFIG,
} from "./constants";
import { sortModuleVersionExamples } from "./helpers";
import { ModuleVersionExampleRow } from "./types";

export const useSortingModuleVersionExamples = (examples: ModuleVersionExampleRow[]) => {
  const { sortDescriptor } = useTableSort({
    filtersOrderSettingsKey: MODULE_VERSION_EXAMPLES_TABLE_FILTERS_STORAGE_KEY,
    sortConfig: SORT_CONFIG,
    initialSortOption: INITIAL_SORT_OPTION,
    initialSortDirection: INITIAL_SORT_DIRECTION,
  });

  return useMemo(
    () => sortModuleVersionExamples(examples, sortDescriptor),
    [examples, sortDescriptor]
  );
};
